import {ErrorMessageComponent} from "./errorMessage.component";

export const ErrorMessage = ErrorMessageComponent;
